<template>
  <div class="fc-org-select">
    <div class="tags">
      <el-button
        v-if="buttonType === 'button' && !isViewForm"
        size="small"
        type="primary"
        icon="el-icon-plus"
        style="margin-bottom: 6px;"
        :disabled="disabled"
        @click="showModal()"
      >
        选择{{ title }}
      </el-button>
      <div
        class="input-box"
        :class="{ 'as-input': buttonType === 'input' }"
        @click="showModal()"
      >
        <el-tag
          v-for="item in selectedData"
          :key="item.key"
          v-bind="tagConfig"
          :closable="!isViewForm"
          :type="isViewForm ? '' : 'info'"
          class="org-tag"
          @close="onClose(item)"
        >
          {{ item.label }}
        </el-tag>
      </div>
    </div>
    <fc-org-transfer
      ref="transfer"
      :companyList="companyList"
      :value="innerValue"
      :title="title"
      :searchable="searchable"
      :maxNum="maxNum"
      :tabList="tabList"
      :type="type"
      :show.sync="show"
      @confirm="onConfirm"
    />
  </div>
</template>
<script>
export default {
  name: "FcOrgSelect",
  model: {
    prop: "value",
    event: "input"
  },
  props: {
    // 公司数据
    companyList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    value: {
      type: Array,
      required: true,
      default: () => []
    },
    tabList: {
      type: Array,
      default: () => ["dep"]
    },
    type: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: "组织机构"
    },
    buttonType: {
      type: String,
      default: "input"
    }, // or input
    searchable: {
      type: Boolean,
      default: true
    },
    maxNum: {
      type: Number,
      default: 99
    },
    tagConfig: {
      type: Object,
      default: () => ({
        type: "info",
        closable: true,
        "disable-transitions": false,
        hit: false,
        color: undefined,
        size: "small",
        effect: "light"
      })
    },
    // 禁用
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tabKeys: [],
      show: false,
      innerValue: [],
      selectedData: []
    };
  },
  computed: {
    selectedLabels() {
      let list = [];
      let companyIds = [];
      let listStr = [];
      console.log(222, this.selectedData);
      this.selectedData.map(item => {
        let index = companyIds.indexOf(item.companyId);
        if (index < 0) {
          list.push({
            companyId: item.companyId,
            companyName: item.companyName,
            list: item.label
          });
          companyIds.push(item.companyId);
        } else {
          list[index].list += "," + item.label;
        }
      });
      if (workFlowConfig.isSingleCompany) {
        return _.map(list, "list").join("");
      }
      list.map(e => {
        listStr.push(`<b>${e.companyName}：</b><br>${e.list}`);
      });
      return listStr.join("<br><br>");
    },
    isViewForm() {
      return this.$parent.$attrs.disabled;
    }
  },
  watch: {
    value: {
      handler: function(val) {
        if (!val) return;
        this.reloadCmpData();
      },
      immediate: true,
      deep: true
    },
    tabList: {
      handler: function(val) {
        this.tabKeys = [];
        val.forEach(t => this.tabKeys.push(typeof t === "string" ? t : t.key));
        this.reloadCmpData();
      },
      immediate: true
    }
  },
  methods: {
    // 显示模态框
    showModal() {
      if (this.isViewForm) {
        return;
      }
      this.show = true;
    },
    // 回显数据
    reloadCmpData() {
      console.log("reloadCmpData----", this.value);
      this.innerValue = this.value;
      this.$nextTick(_ => {
        this.initSelectedData();
      });
    },
    // 初始化数据
    initSelectedData() {
      this.selectedData = this.innerValue;
    },
    // 取消
    onClose(item) {
      const list = this.innerValue;
      const index = item.id
        ? list.findIndex(t => t.id === item.id)
        : list.findIndex(t => t.value === item.value);
      console.log(5555, list, item, index);
      index > -1 && list.splice(index, 1);
      this.initSelectedData();
      this.$emit("input", this.innerValue);
      this.$emit("change", this.innerValue);
    },
    // 确定
    onConfirm(data) {
      // console.log("333确定", data);
      this.innerValue = _.cloneDeep(data);
      this.initSelectedData();
      this.$emit("input", this.innerValue);
      this.$emit("change", data);
    }
  }
};
</script>
<style lang="less" scoped>
.tags {
  .input-box.as-input {
    border: 1px solid #dcdfe6;
    padding-left: 6px;
    font-size: 12px;
    min-height: 32px;
    line-height: 30px;
    border-radius: 4px;
    background: white;
    color: #606266;
    cursor: pointer;
  }
  .org-tag {
    margin-right: 6px;
    max-width: 6rem;
    overflow: hidden;
    text-overflow: ellipsis;
    position: relative;
    padding-right: 1rem;
    vertical-align: middle;

    > .el-tag__close {
      position: absolute;
      right: 2px;
      top: 50%;
      margin-top: -7px;
    }
  }
}
</style>
